module.exports = __webpack_public_path__ + "ad.no1.e67e635d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ad.no1.jpg
// module id = WF6n
// module chunks = 0